import React from 'react';
import { BiPlus } from 'react-icons/bi';

import { ADD_RECORD_ROW_LABEL } from 'constants/messageConstants';

interface AddRecordRowProps {
  searchText: string;
  onClick: () => void;
  /**
   * Act on mouse-down instead of on click. For a row inside a dropdown, which
   * can close (and remove the row) on mouse-down, before a click ever lands.
   * Keyboard activation still works.
   */
  activateOnMouseDown?: boolean;
}

/** "Add '<text>'" row offered when a picker search finds nothing (OP-2498). */
const AddRecordRow: React.FC<AddRecordRowProps> = ({
  searchText,
  onClick,
  activateOnMouseDown = false,
}) => (
  <button
    type="button"
    className="flex w-full items-center gap-3 border-y border-gray-bright bg-success-light px-3 py-3 text-left outline-none transition-colors hover:bg-gray-smoke focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-charcoal"
    onMouseDown={
      activateOnMouseDown
        ? (event) => {
            // Keeps focus in the dropdown's search, as its own options do.
            event.preventDefault();
            onClick();
          }
        : undefined
    }
    onClick={(event) => {
      // A mouse click was already handled on mouse-down; keyboard is not.
      if (activateOnMouseDown && event.detail > 0) return;
      onClick();
    }}
  >
    {/* Same mark as mobile: a white plus in a dark green circle. */}
    <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success-dark text-white">
      <BiPlus className="text-base" aria-hidden />
    </span>
    <span className="min-w-0 truncate text-base font-semibold text-charcoal">
      {ADD_RECORD_ROW_LABEL(searchText.trim())}
    </span>
  </button>
);

export default AddRecordRow;
